'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CallbackPageContainer = require('./CallbackPageContainer');

var _CallbackPageContainer2 = _interopRequireDefault(_CallbackPageContainer);

var _OidcUserManager = require('../../services/OidcUserManager');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OidcManager = function (_React$Component) {
  (0, _inherits3.default)(OidcManager, _React$Component);

  function OidcManager(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, OidcManager);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OidcManager.__proto__ || (0, _getPrototypeOf2.default)(OidcManager)).call(this, props));

    _this.setReady = function () {
      _this.setState({
        isReady: true
      });
    };

    _this.handleError = function (component) {
      // render error component if error
      if (_this.props.oidcError) {
        return _this.props.errorComponent ? _react2.default.createElement(_this2.props.errorComponent, { oidcError: _this.props.oidcError }) : null;
      }

      return component;
    };

    _this.state = {
      isReady: false
    };
    return _this;
  }

  (0, _createClass3.default)(OidcManager, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.isRedirectUri) {
        this.setReady(); // render callback component
        return;
      }

      // Attempt to automatically log in
      (0, _OidcUserManager.userManager)().signinSilent()
      // if already logged in, render app
      .then(this.setReady)
      // if not logged in, show logincomponent
      .catch(this.setReady);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.hasUser && !prevProps.hasUser) {
        this.setReady();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isRedirectUri = _props.isRedirectUri,
          hasUser = _props.hasUser,
          loginComponent = _props.loginComponent,
          children = _props.children;

      var loadingComponent = this.props.loadingComponent || null;

      // render loading component if loading or redirecting
      if (!this.state.isReady || this.props.oidcRedirecting) {
        return loadingComponent;
      }

      // render callback component if currently in redirect uri
      if (isRedirectUri) {
        return this.handleError(_react2.default.createElement(_CallbackPageContainer2.default, { loadingComponent: loadingComponent }));
      }

      // render logincomponent if user not found
      // if no logincomponent, render loadingcomponent since app is prob in process of signing in
      if (!hasUser) {
        return this.handleError(loginComponent || loadingComponent);
      }

      // render app once user auth data is loaded. even if there is an oidcError, since the user is logged in, don't show the error
      return children;
    }
  }]);
  return OidcManager;
}(_react2.default.Component);

exports.default = OidcManager;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/oidc/OidcManager.js
// module id = 752
// module chunks = 10